/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { assetImages } from "constants";
import { useTranslation } from "react-i18next";

import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import {
  appUserHeaderLinks,
  appUserProfileLink,
} from "helper/AppUserHelper/AppUserHelper";

// Timeline Item Component
const TimelineItem = ({ event, t, index, selectedIds, toggleSelection }) => {
  const getEventIcon = (type) => {
    const icons = {
      vaccination: "vaccines",
      medical_test: "biotech",
      treatment: "medical_services",
      created: "event_available",
      appointment: "calendar_month",
      appointment_completed: "check_circle",
      appointment_cancelled: "cancel",
      email_sent: "mail",
      note_added: "note_add",
      survey_sent: "assignment",
      survey_responded: "assignment_turned_in",
      lab_test: "science",
      prescription: "medication",
      payment: "payments",
      document_uploaded: "upload_file",
      patient_created: "person_add",
    };
    return icons[type] || "event";
  };

  const getEventColor = (type) => {
    return "primary";
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMs = now - date;
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const diffInWeeks = Math.floor(diffInDays / 7);
    const diffInMonths = Math.floor(diffInDays / 30);

    if (diffInHours < 1) return t("Just now");
    if (diffInHours < 24) return `${diffInHours} ${t("hours ago")}`;
    if (diffInDays === 1) return t("Yesterday");
    if (diffInDays < 7) return `${diffInDays} ${t("days ago")}`;
    if (diffInWeeks === 1) return t("1 week ago");
    if (diffInWeeks < 4) return `${diffInWeeks} ${t("weeks ago")}`;
    if (diffInMonths === 1) return t("1 month ago");
    if (diffInMonths < 12) return `${diffInMonths} ${t("months ago")}`;

    return date.toLocaleDateString();
  };

  // Format date as DD/MM/YYYY, HH:MM:SS AM/PM
  const formatDateTimeDMY = (dateString) => {
    const d = new Date(dateString);
    const day = d.getDate();
    const month = d.getMonth() + 1;
    const year = d.getFullYear();
    let hours = d.getHours();
    const minutes = d.getMinutes().toString().padStart(2, "0");
    const seconds = d.getSeconds().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds} ${ampm}`;
  };

  const getModuleName = (slug) => {
    const moduleNames = {
      MOD_VACCINE: t("Vaccination"),
      MOD_LAB_TEST: t("Lab Test"),
      MOD_TREATMENT: t("Treatment"),
      MOD_AGENDA: t("Appointment"),
      MOD_PRESCRIPTION: t("Prescription"),
      MOD_WEIGHT: t("Weight"),
      MOD_HEIGHT: t("Height"),
      MOD_BLOOD_PRESSURE: t("Blood Pressure"),
      MOD_HEAD_CIRCUMFERENCE: t("Head Circumference"),
      MOD_RESPIRATION: t("Respiration Rate"),
      MOD_TEMPERATURE: t("Temperature"),
      MOD_OXYGEN_SATURATION: t("Oxygen Saturation"),
      MOD_HEART_RATE: t("Heart Rate"),
      MOD_CONTACT: t("Contact"),
      MOD_LEAD: t("Lead"),
    };
    return moduleNames[slug] || slug;
  };

  return (
    <div
      className="timeline-item d-flex gap-3 mb-4"
      style={{
        animation: `fadeInUp 0.5s ease-out ${index * 0.1}s both`,
      }}
    >
      <div className="timeline-icon-wrapper position-relative">
        <div
          className={`timeline-icon bg-${getEventColor(event.type)} text-white rounded-circle d-flex align-items-center justify-content-center shadow-sm`}
          style={{
            width: "48px",
            height: "48px",
            minWidth: "48px",
            transition: "all 0.3s ease",
          }}
        >
          <span
            className="material-symbols-outlined"
            style={{ fontSize: "24px" }}
          >
            {getEventIcon(event.type)}
          </span>
        </div>
        {!event.isLast && (
          <div
            className="timeline-line position-absolute"
            style={{
              width: "2px",
              background:
                "linear-gradient(180deg, #dee2e6 0%, transparent 100%)",
              left: "23px",
              top: "56px",
              height: "calc(100% - 40px)",
            }}
          ></div>
        )}
      </div>
      <div className="timeline-content flex-grow-1">
        <div
          className="card border-0 shadow-sm hover-lift"
          style={{
            transition: "all 0.3s ease",
            borderLeft: `4px solid var(--bs-${getEventColor(event.type)})`,
          }}
        >
          <div className="card-body p-3 p-md-4">
            <div className="d-flex justify-content-between align-items-start mb-2 flex-wrap gap-2">
              <div className="flex-grow-1">
                <div className="d-flex align-items-center gap-2 mb-1">
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(event._id)}
                    onChange={() => toggleSelection(event._id)}
                    className="me-2"
                  />
                  <span
                    className={`badge bg-${getEventColor(event.type)} bg-opacity-10 text-${getEventColor(event.type)} px-2 py-1`}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {getModuleName(event.moduleslug)}
                  </span>
                </div>
                <h6
                  className="mb-0 fw-semibold mt-2"
                  style={{ fontSize: "1.1rem" }}
                >
                  {event.title}
                </h6>
              </div>
              <small className="text-muted d-flex align-items-center gap-1">
                <span
                  className="material-symbols-outlined"
                  style={{ fontSize: "16px" }}
                >
                  schedule
                </span>
                {formatDate(event.createdAt)}
              </small>
            </div>

            <p className="text-muted mb-3" style={{ fontSize: "0.95rem" }}>
              {event.description}
            </p>

            {event.doctorname && (
              <p className="text-muted mb-1" style={{ fontSize: "0.9rem" }}>
                <strong>{t("Doctor")}:</strong> {event.doctorname}
              </p>
            )}
            {event.companyname && (
              <p className="text-muted mb-1" style={{ fontSize: "0.9rem" }}>
                <strong>{t("Company")}:</strong> {event.companyname}
              </p>
            )}

            {/* {event.data && (
              <div
                className="event-details mt-2 p-3 rounded"
                style={{
                  backgroundColor: "rgba(var(--bs-primary-rgb), 0.05)",
                  borderLeft: "3px solid var(--bs-primary)",
                }}
              >
                <small className="text-dark d-flex align-items-center gap-2">
                  <span
                    className="material-symbols-outlined"
                    style={{ fontSize: "16px" }}
                  >
                    info
                  </span>
                  <span className="fw-medium">{t("ID")}:</span> {event.data}
                </small>
              </div>
            )} */}

            <div className="mt-3 pt-3 border-top d-flex justify-content-between align-items-center flex-wrap gap-2">
              <div className="d-flex align-items-center gap-3">
                {/* {event.createdby && (
                  <small className="text-muted d-flex align-items-center gap-1">
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "16px", verticalAlign: "middle" }}
                    >
                      person
                    </span>
                    {t("Created by")}: {event.createdby}
                  </small>
                )} */}
                {event.followers && event.followers.length > 0 && (
                  <small className="text-muted d-flex align-items-center gap-1">
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "16px", verticalAlign: "middle" }}
                    >
                      group
                    </span>
                    {event.followers.length} {t("follower(s)")}
                  </small>
                )}
              </div>
              <small className="text-muted">
                {/* {new Date(event.createdAt).toLocaleString()} */}
                {formatDateTimeDMY(event.createdAt)}{" "}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Filter Component
const TimelineFilter = ({ selectedType, onFilterChange, eventTypes, t }) => {
  return (
    <div className="filter-container py-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
        <div className="d-flex gap-2 flex-wrap">
          <button
            className={`btn ${selectedType === "all" ? "btn-primary" : "btn-outline-primary"} btn-sm`}
            onClick={() => onFilterChange("all")}
          >
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "18px", verticalAlign: "middle" }}
            >
              select_all
            </span>
            {t("All")} ({eventTypes.all || 0})
          </button>
          {Object.entries(eventTypes)
            .filter(([key]) => key !== "all")
            .map(([type, count]) => (
              <button
                key={type}
                className={`btn ${selectedType === type ? "btn-primary" : "btn-outline-primary"} btn-sm`}
                onClick={() => onFilterChange(type)}
              >
                {type.replace(/_/g, " ")} ({count})
              </button>
            ))}
        </div>
      </div>
    </div>
  );
};

// Statistics Card Component
const StatCard = ({ icon, label, value, color = "primary", t }) => {
  return (
    <div className="stat-card mb-3">
      <div className="card border-0 shadow-sm h-100">
        <div className="card-body p-3">
          <div className="d-flex align-items-center gap-3">
            <div
              className={`stat-icon bg-${color} bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center`}
              style={{ width: "50px", height: "50px", minWidth: "50px" }}
            >
              <span
                className={`material-symbols-outlined text-${color}`}
                style={{ fontSize: "28px" }}
              >
                {icon}
              </span>
            </div>
            <div className="flex-grow-1">
              <small
                className="text-muted d-block mb-1"
                style={{ fontSize: "0.8rem" }}
              >
                {label}
              </small>
              <h4 className="mb-0 fw-bold">{value}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AppUserTimelineBody = () => {
  const token = localStorage.getItem("token");
  const { t } = useTranslation();
  const params = useParams();
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const commonHeaderObject = appUserHeaderLinks(params.id, t);

  // User details
  const [userLoading, setUserLoading] = useState(false);
  const [userName, setUserName] = useState("");
  const [userImage, setUserImage] = useState("");
  const [userRoleName, setUserRoleName] = useState("");
  const [userPersonId, setUserPersonId] = useState(null);
  const [timeLinesData, setTimeLinesData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [isLoading, setIsLoading] = useState(false);

  const [isDataReady, setIsDataReady] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [selectedIds, setSelectedIds] = useState([]);

  // AI Recommendation states
  const [selectedNoteEmails, setSelectedNoteEmails] = useState("");
  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");

  // Get user details
  const getAppuserDetails = async () => {
    try {
      setUserLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_DETAILS +
        `/${params.id}`;

      const response = await getData(requestUrl);

      console.log("response in getAppuserDetails", response);

      if (response.status && response.data) {
        setUserName(response.data.userfullname || "");
        setUserImage(response.data.userimage || "");
        setUserRoleName(response.data.role?.name || "");
        setUserPersonId(response.data._id);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    } finally {
      setUserLoading(false);
    }
  };

  // Get patient timeline
  const getUserTimeLine = async () => {
    setIsLoading(true);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_TIMELINE_EVENTS +
        `?modulefrom=USER_MANAGEMENT&userids=${params.id}`;

      console.log("requestUrl in getPatientTimeLine", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in getPatientTimeLine", response);

      if (response.status && response.data) {
        // Mark the last item
        const dataWithLastFlag = response.data.map((item, index) => ({
          ...item,
          isLast: index === response.data.length - 1,
        }));

        setTimeLinesData(dataWithLastFlag);
        setFilteredData(dataWithLastFlag);
        setMessageType("success");
      } else {
        setMessageType("error");
        setTimeLinesData([]);
        setFilteredData([]);
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message || t("Failed to fetch timeline data"));
      setMessageType("error");
      setTimeLinesData([]);
      setFilteredData([]);
    } finally {
      setIsLoading(false);
      setShowAlert(true);
    }
  };

  useEffect(() => {
    if (params.id) {
      const initialData = async () => {
        await getAppuserDetails();
        await getUserTimeLine();
        setIsDataReady(true);
      };
      initialData();
    }
  }, [params.id]);

  // Filter timeline data
  useEffect(() => {
    if (selectedFilter === "all") {
      setFilteredData(timeLinesData);
    } else {
      setFilteredData(
        timeLinesData.filter((item) => item.type === selectedFilter),
      );
    }
  }, [selectedFilter, timeLinesData]);

  // Get event types count
  const getEventTypesCount = () => {
    const counts = { all: timeLinesData.length };
    timeLinesData.forEach((item) => {
      counts[item.type] = (counts[item.type] || 0) + 1;
    });
    return counts;
  };

  // Get latest activity time
  const getLatestActivityTime = () => {
    if (timeLinesData.length === 0) return t("No activity");
    const latest = timeLinesData[0];
    const date = new Date(latest.createdAt);
    const now = new Date();
    const diffInMs = now - date;
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));

    if (diffInHours < 1) return t("Just now");
    if (diffInHours < 24) return `${diffInHours} ${t("hours ago")}`;
    return date.toLocaleDateString();
  };

  // Get unique module count
  const getUniqueModulesCount = () => {
    const uniqueModules = new Set(timeLinesData.map((item) => item.moduleslug));
    return uniqueModules.size;
  };

  const toggleSelection = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const handleSelectAll = () => {
    if (selectedIds.length === filteredData.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(filteredData.map((item) => item._id));
    }
  };

  const onShowAiRecommendation = () => {
    // This function can be used to prepare data before showing the offcanvas
    console.log("Selected Note IDs:", selectedIds);
  };

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (userInfo.role.slug === "ADMIN" || userInfo.role.slug === "SUPER_ADMIN") {
    return (
      <div id="content_wrapper">
        <section className="patient-timeline-wrapper bg-light pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("Timeline")}
          />
          <div className="container-fluid px-lg-5 mt-3">
            {/* user-header block */}
            {userLoading || !isDataReady ? (
              <div className="patient-header shadow-sm border border-2 border-primary rounded-3 bg-white">
                <div className="d-flex align-items-center gap-3 flex-wrap">
                  <span className="placeholder-glow">
                    <span
                      className="placeholder rounded-circle border border-3 border-primary shadow me-2"
                      style={{ width: 80, height: 80, display: "inline-block" }}
                    ></span>
                  </span>
                  <div className="flex-grow-1">
                    <h4 className="mb-1 fw-bold text-dark d-flex align-items-center gap-2 placeholder-glow">
                      <span className="placeholder col-6"></span>
                      <span className="placeholder badge bg-primary bg-opacity-10 text-primary px-2 py-1 fs-xs fw-normal col-2"></span>
                    </h4>
                    <p className="mb-0 text-muted d-flex align-items-center gap-2 placeholder-glow">
                      <span className="placeholder col-4"></span>
                    </p>
                    <p className="mb-0 mt-1 text-muted small d-flex align-items-center gap-2 placeholder-glow">
                      <span className="placeholder col-3"></span>
                    </p>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    <span className="placeholder-glow">
                      <span
                        className="placeholder btn btn-primary"
                        style={{ minWidth: 120, height: 38 }}
                      ></span>
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="patient-header shadow-sm border border-2 border-primary rounded-3 bg-white">
                <div className="d-flex align-items-center gap-3 flex-wrap">
                  <div className="position-relative">
                    <img
                      className="rounded-circle border border-3 border-primary shadow"
                      height={80}
                      width={80}
                      src={
                        userImage === "" || !userImage
                          ? assetImages.defaultUser
                          : url.SERVER_URL + userImage
                      }
                      alt="Patient"
                    />
                    <div
                      className="position-absolute bottom-0 end-0 bg-success rounded-circle border border-2 border-white"
                      style={{ width: "20px", height: "20px" }}
                      title={t("Active")}
                    ></div>
                  </div>
                  <div className="flex-grow-1">
                    <h4 className="mb-1 fw-bold text-dark d-flex align-items-center gap-2">
                      {userName || t("User Name")}
                      <span className="badge bg-primary bg-opacity-10 text-primary px-2 py-1 fs-xs fw-normal">
                        {userRoleName}
                      </span>
                    </h4>
                    <p className="mb-0 text-muted d-flex align-items-center gap-2">
                      <span
                        className="material-symbols-outlined text-primary"
                        style={{ fontSize: "18px" }}
                      >
                        timeline
                      </span>
                      {t("Timeline & Activity History")}
                    </p>
                    {timeLinesData.length > 0 && (
                      <p className="mb-0 mt-1 text-muted small d-flex align-items-center gap-2">
                        <span
                          className="material-symbols-outlined"
                          style={{ fontSize: "16px" }}
                        >
                          event_note
                        </span>
                        {timeLinesData.length} {t("total events")} •{" "}
                        {t("Last activity")}: {getLatestActivityTime()}
                      </p>
                    )}
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    {/* <button
                    className={`btn ${
                      selectedIds.length === 0
                        ? "btn-outline-primary"
                        : "btn-primary"
                    } d-flex align-items-center gap-2 shadow-sm`}
                    data-bs-toggle={
                      selectedIds.length === 0 ? undefined : "offcanvas"
                    }
                    data-bs-target={
                      selectedIds.length === 0
                        ? undefined
                        : "#aiRecommendationModal"
                    }
                    onClick={
                      selectedIds.length > 0
                        ? onShowAiRecommendation
                        : undefined
                    }
                    disabled={selectedIds.length === 0}
                    title={
                      selectedIds.length === 0
                        ? t("Select events to get AI recommendations")
                        : t("Get AI Recommendations")
                    }
                  >
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "20px" }}
                    >
                      smart_toy
                    </span>
                    <span className="d-none d-md-inline">
                      {t("AI Recommend")}
                    </span>
                    {selectedIds.length > 0 && (
                      <span className="badge bg-white text-primary ms-1 fw-semibold">
                        {selectedIds.length}
                      </span>
                    )}
                  </button> */}
                    <button
                      className="btn btn-primary d-flex align-items-center gap-2 shadow-sm"
                      onClick={() => getUserTimeLine()}
                      disabled={isLoading}
                      title={t("Reload Timeline")}
                    >
                      <span
                        className="material-symbols-outlined"
                        style={{ fontSize: "20px" }}
                      >
                        {isLoading ? "hourglass_empty" : "refresh"}
                      </span>
                      <span className="d-none d-md-inline">
                        {isLoading ? t("Loading...") : t("Refresh")}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div className="row mt-4">
              <div className="col-lg-8 mb-4 mb-lg-0">
                <div className="bg-white rounded-3 shadow-sm p-4">
                  {userLoading || !isDataReady ? (
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h5 className="mb-0 fw-bold d-flex align-items-center gap-2 placeholder-glow">
                        <span
                          className="placeholder rounded-circle bg-primary bg-opacity-25"
                          style={{ width: 32, height: 32 }}
                        ></span>
                        <span
                          className="placeholder col-3"
                          style={{ height: 16, width: 150 }}
                        ></span>
                      </h5>
                      <div className="d-flex align-items-center gap-2">
                        <span className="placeholder-glow">
                          <span
                            className="placeholder btn btn-outline-primary"
                            style={{ minWidth: 100, height: 32 }}
                          ></span>
                        </span>
                        <span className="placeholder-glow">
                          <span
                            className="placeholder btn btn-outline-primary"
                            style={{ minWidth: 80, height: 32 }}
                          ></span>
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
                        <span className="material-symbols-outlined text-primary">
                          history
                        </span>
                        {t("Timeline Events")}
                      </h5>
                      <div className="d-flex align-items-center gap-2">
                        {filteredData.length > 0 && (
                          <button
                            className="btn btn-sm btn-outline-primary d-flex align-items-center gap-2"
                            onClick={handleSelectAll}
                          >
                            <span
                              className="material-symbols-outlined"
                              style={{ fontSize: "18px" }}
                            >
                              {selectedIds.length === filteredData.length
                                ? "deselect"
                                : "select_all"}
                            </span>
                            {selectedIds.length === filteredData.length
                              ? t("Deselect All")
                              : t("Select All")}
                          </button>
                        )}
                        <button
                          className="btn btn-outline-primary bg-primary bg-opacity-10 text-primary"
                          style={{ cursor: "default" }}
                        >
                          {filteredData.length} {t("events")}
                        </button>
                      </div>
                    </div>
                  )}

                  {userLoading || !isDataReady ? (
                    <div className="filter-container py-3 mb-3">
                      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                        <div className="d-flex gap-2 flex-wrap">
                          {[...Array(4)].map((_, idx) => (
                            <span className="placeholder-glow" key={idx}>
                              <span
                                className="placeholder btn btn-outline-primary"
                                style={{ minWidth: 90, height: 32 }}
                              ></span>
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <TimelineFilter
                      selectedType={selectedFilter}
                      onFilterChange={setSelectedFilter}
                      eventTypes={getEventTypesCount()}
                      t={t}
                    />
                  )}

                  {isLoading ? (
                    <div className="text-center py-5">
                      <div className="loading-spinner mx-auto mb-3"></div>
                      <p className="text-muted">
                        {t("Loading timeline data...")}
                      </p>
                    </div>
                  ) : filteredData.length > 0 ? (
                    <div className="timeline-container">
                      {filteredData.map((event, index) => (
                        <TimelineItem
                          key={event._id}
                          event={event}
                          t={t}
                          index={index}
                          selectedIds={selectedIds}
                          toggleSelection={toggleSelection}
                        />
                      ))}
                    </div>
                  ) : isDataReady ? (
                    <div className="empty-state">
                      <span className="material-symbols-outlined empty-state-icon">
                        event_busy
                      </span>
                      <h5 className="text-muted mb-2">
                        {t("No timeline events found")}
                      </h5>
                      <p className="text-muted">
                        {selectedFilter === "all"
                          ? t(
                              "There are no events to display for this patient.",
                            )
                          : t(
                              "No events found for the selected filter. Try a different filter.",
                            )}
                      </p>
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="col-lg-4">
                <div className="sticky-top" style={{ top: "20px" }}>
                  <h5 className="mb-3 fw-bold d-flex align-items-center gap-2">
                    <span className="material-symbols-outlined text-primary">
                      analytics
                    </span>
                    {t("Activity Summary")}
                  </h5>

                  {userLoading || !isDataReady ? (
                    <>
                      {/* StatCard placeholders */}
                      {[...Array(3)].map((_, idx) => (
                        <div
                          className="card border-0 shadow-sm mb-3 placeholder-glow"
                          key={idx}
                        >
                          <div className="card-body d-flex align-items-center gap-3">
                            <span
                              className="placeholder rounded-circle bg-primary bg-opacity-25"
                              style={{ width: 32, height: 32 }}
                            ></span>
                            <div className="flex-grow-1">
                              <p
                                className="placeholder col-4 mb-2 placeholder-glow"
                                style={{ height: 10 }}
                              ></p>
                            </div>
                          </div>
                        </div>
                      ))}
                      {/* Event Distribution placeholder */}
                      <div className="card border-0 shadow-sm mt-3 placeholder-glow">
                        <div className="card-body">
                          <span
                            className="placeholder col-6 mb-3"
                            style={{ height: 18 }}
                          ></span>
                          {[...Array(3)].map((_, idx) => (
                            <div key={idx} className="mb-2">
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <span className="placeholder col-3"></span>
                                <span className="placeholder col-1"></span>
                              </div>
                              <div
                                className="progress"
                                style={{ height: "6px" }}
                              >
                                <div
                                  className="progress-bar bg-primary placeholder"
                                  style={{ width: "100%" }}
                                ></div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <StatCard
                        icon="event_note"
                        label={t("Total Events")}
                        value={timeLinesData.length}
                        color="primary"
                        t={t}
                      />

                      <StatCard
                        icon="schedule"
                        label={t("Last Activity")}
                        value={getLatestActivityTime()}
                        color="success"
                        t={t}
                      />

                      <StatCard
                        icon="category"
                        label={t("Active Modules")}
                        value={getUniqueModulesCount()}
                        color="info"
                        t={t}
                      />

                      {timeLinesData.length > 0 && (
                        <div className="card border-0 shadow-sm mt-3">
                          <div className="card-body">
                            <h6 className="fw-semibold mb-3 d-flex align-items-center gap-2">
                              <span className="material-symbols-outlined text-warning">
                                bar_chart
                              </span>
                              {t("Event Distribution")}
                            </h6>
                            {Object.entries(getEventTypesCount())
                              .filter(([key]) => key !== "all")
                              .map(([type, count]) => (
                                <div key={type} className="mb-2">
                                  <div className="d-flex justify-content-between align-items-center mb-1">
                                    <small className="text-muted text-capitalize">
                                      {type.replace(/_/g, " ")}
                                    </small>
                                    <small className="fw-semibold">
                                      {count}
                                    </small>
                                  </div>
                                  <div
                                    className="progress"
                                    style={{ height: "6px" }}
                                  >
                                    <div
                                      className="progress-bar bg-primary"
                                      role="progressbar"
                                      style={{
                                        width: `${(count / timeLinesData.length) * 100}%`,
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}

        {/* <AiRecommendationPopup
          timelineids={selectedIds}
          selectedNoteEmails={selectedNoteEmails}
          setSelectedNoteEmails={setSelectedNoteEmails}
          subject={subject}
          setSubject={setSubject}
          content={content}
          setContent={setContent}
        /> */}

        <style>
          {`
            @keyframes fadeInUp {
              from {
                opacity: 0;
                transform: translateY(20px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }

            .hover-lift {
              transition: all 0.3s ease;
            }

            .hover-lift:hover {
              transform: translateY(-2px);
              box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.15) !important;
            }

            .timeline-icon {
              position: relative;
              z-index: 2;
            }

            .timeline-icon-wrapper:hover .timeline-icon {
              transform: scale(1.1);
            }

            .stat-card {
              animation: fadeInUp 0.5s ease-out both;
            }

            .stat-card:nth-child(1) { animation-delay: 0.1s; }
            .stat-card:nth-child(2) { animation-delay: 0.2s; }
            .stat-card:nth-child(3) { animation-delay: 0.3s; }

            .patient-header {
              padding: 1.5rem 2rem;
              margin-bottom: 2rem;
              transition: all 0.3s ease;
              background: linear-gradient(135deg, rgba(var(--bs-primary-rgb), 0.02) 0%, rgba(var(--bs-primary-rgb), 0.05) 100%);
            }

            .patient-header:hover {
              box-shadow: 0 0.5rem 1.5rem rgba(var(--bs-primary-rgb), 0.15) !important;
            }

            .patient-header h4 {
              font-size: 1.5rem;
              letter-spacing: -0.5px;
            }

            .patient-header .btn {
              font-weight: 500;
              padding: 0.625rem 1.25rem;
              border-radius: 8px;
              transition: all 0.3s ease;
            }

            .patient-header .btn:hover:not(:disabled) {
              transform: translateY(-2px);
              box-shadow: 0 4px 12px rgba(var(--bs-primary-rgb), 0.25) !important;
            }

            .patient-header .btn:disabled {
              opacity: 0.6;
              cursor: not-allowed;
            }

            .patient-header img {
              object-fit: cover;
              transition: all 0.3s ease;
            }

            .patient-header img:hover {
              transform: scale(1.05);
            }

            @media (max-width: 768px) {
              .patient-header {
                padding: 1rem;
              }

              .patient-header h4 {
                font-size: 1.25rem;
              }

              .patient-header .btn {
                padding: 0.5rem 1rem;
              }
            }

            .filter-container .btn-sm {
              padding: 0.5rem 1rem;
              font-size: 0.875rem;
              border-radius: 20px;
              transition: all 0.3s ease;
            }

            .loading-spinner {
              display: inline-block;
              width: 40px;
              height: 40px;
              border: 4px solid rgba(0, 0, 0, 0.1);
              border-radius: 50%;
              border-top-color: #667eea;
              animation: spin 1s ease-in-out infinite;
            }

            @keyframes spin {
              to { transform: rotate(360deg); }
            }

            .empty-state {
              text-align: center;
              padding: 4rem 2rem;
            }

            .empty-state-icon {
              font-size: 80px;
              color: #dee2e6;
              margin-bottom: 1rem;
            }
          `}
        </style>
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="patient-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default AppUserTimelineBody;
